import {useTranslation} from 'react-i18next';

import {Grid} from '@mui/material';

import {Column} from '../Column/Column';

import {ValidationText} from './ValidationText';
import {
  validateHasLowerCaseLetter,
  validateHasNumeral,
  validateHasSpecialCharacter,
  validateHasUpperCaseLetter,
  validateMinLength,
  validateMaxLength,
} from '../../utils/validators';

interface Props {
  password: string;
}
export const PasswordValidations = ({password}: Props) => {
  const hasMinLength = validateMinLength(password);
  const hasMaxLength = validateMaxLength(password);
  const hasSpecialChar = validateHasSpecialCharacter(password);
  const hasNumeral = validateHasNumeral(password);
  const hasUpperCase = validateHasUpperCaseLetter(password);
  const hasLowerCase = validateHasLowerCaseLetter(password);
  const {t} = useTranslation('translation', {keyPrefix: 'passwordReset.validations'});

  return (
    <Grid container flexDirection='row' paddingBottom='8px'>
      <Column gap='0px'>
        <ValidationText text={t('length')} isValid={hasMinLength} />
        <ValidationText text={t('maxLength')} isValid={hasMaxLength} />
        <ValidationText text={t('lowerCase')} isValid={hasLowerCase} />
      </Column>
      <Column gap='0px'>
        <ValidationText text={t('upperCase')} isValid={hasUpperCase} />
        <ValidationText text={t('numeral')} isValid={hasNumeral} />
        <ValidationText text={t('specialCharacter')} isValid={hasSpecialChar} />
      </Column>
    </Grid>
  );
};
